$(document).ready(function(){
  $(".testimonials").slick({
    infinite: true,
    arrows: true,
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<div class="arrow-left"><img src="//cosmicgazerart.com/cdn/shop/t/8/assets/black-arrow-left.png?v=79504478389581545231628495404"></div>',
    nextArrow: '<div class="arrow-right"><img src="//cosmicgazerart.com/cdn/shop/t/8/assets/black-arrow-right.png?v=13200163168748177421628495412"></div>',
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
    	  slidesToScroll: 1
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
    	  slidesToScroll: 1
        }
      }                     	  
    ]
  });
});

$(document).ready(function(){
  var show = $(".action-bar__menu--subsub").attr("data-grandchild-show");
  if(show == 'true'){
    $(".action-bar__menu--sub").hide();
  }
  $(".action-bar__menu--subsub .action-bar__back").click(function(){
    $(".action-bar__menu--subsub").hide();
    $(".action-bar__menu--sub").addClass("action-bar--show").show();
  });
  $(".action-bar__menu--sub .action-bar__back").click(function(){
    $(".action-bar__menu--sub").removeClass("action-bar--show").hide();
    $(".action-bar__menu--main").addClass("action-bar--show");
  });
  $(".action-bar__menu--main .action-bar--active").click(function(){
    $(".action-bar__menu--sub").show();
  });

  $(".action-bar__menu--subsub li").each(function(){
    if($(this).hasClass("action-bar--active")){
      $(".action-bar__menu--main").removeClass("action-bar--show");
      $(".action-bar__menu--subsub").addClass("action-bar--show").show();
    }
  });
});